import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import ReactSVG from 'react-svg'
import styled from 'styled-components';
import DefaultButton from './../../../components/DefaultButton';
import { translate } from "react-i18next";
import IconMapMode from './../../../icons/map.svg';
import IconGalleryMode from './../../../icons/image.svg';
import IconVideoMode from './../../../icons/video.svg';
import IconVideoLiveMode from './../../../icons/videoLive.svg';
import IconModelMode from './../../../icons/3d.svg';
import AttachmentIcon from './../../../icons/clip.svg';
import {
    openDefault,
    openVideo,
    openGallery,
    openModel,
    openResource,
    openStream
} from './../../../actions/modules';

const ModeButtonsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 10;
    top: 3px;
    right: 3px;
`;

export class ModeButtonsContainer extends React.Component<Props, State> {
    render() {
        const { t, selected, chosenProject, isStreamTransmiting } = this.props;
        const { license } = chosenProject;
        return (
            <ModeButtonsContainerStyled>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                    }}
                    title={t('Map')}
                    active={selected === 'default'}
                    onClick={() => this.props.openDefault()}>
                    <ReactSVG
                        path={IconMapMode}
                        style={{
                            fill: selected === 'default' ? '#ffffff' : '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                    }}
                    disabled={!license.videoEnabled}
                    title={t('Videos')}
                    active={selected === 'video'}
                    onClick={() => this.props.openVideo()}>
                    <ReactSVG
                        path={IconVideoMode}
                        style={{
                            fill: selected === 'video' ? '#ffffff' : '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                    }}
                    title={t('Photos')}
                    active={selected === 'gallery'}
                    onClick={() => this.props.openGallery()}>
                    <ReactSVG
                        path={IconGalleryMode}
                        style={{
                            padding: '5px',
                            fill: selected === 'gallery' ? '#ffffff' : '#dddddd',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                    }}
                    title={t('Models')}
                    active={selected === 'model'}
                    onClick={() => this.props.openModel() }>
                    <ReactSVG
                        path={IconModelMode}
                        style={{
                            padding: '5px',
                            fill: selected === 'model' ? '#ffffff' : '#dddddd',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                    }}
                    title={t('Attachments')}
                    active={selected === 'resource'}
                    onClick={() => this.props.openResource()}
                    >
                    <ReactSVG
                        path={AttachmentIcon}
                        style={{
                            fill: selected === 'resource' ? '#ffffff' : '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                        display: isStreamTransmiting ? 'flex' : 'none'
                    }}
                    type='live'
                    title={t('Stream live')}
                    active={selected === 'stream'}
                    onClick={() => this.props.openStream()}
                    >
                    <ReactSVG
                        path={selected === 'stream' ? IconVideoLiveMode : IconVideoMode}
                        style={{
                            fill: selected === 'resource' ? '#ffffff' : '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
            </ModeButtonsContainerStyled>
        );
    }
};

const mapStateToProps = state => ({
    selected: state.modules.get('selected'),
    chosenProject: state.auth.get('chosenProject'),
    isStreamTransmiting: state.video.get('isStreamTransmiting'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    openDefault,
    openVideo,
    openGallery,
    openModel,
    openResource,
    openStream
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ModeButtonsContainer));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/ModeButtonsContainer.jsx